export default __webpack_public_path__ + "static/media/toolTipRight.9fbcdb9b.svg";